import * as React from 'react';
import { graphql, Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Helmet } from 'react-helmet';
import SinglePhotoLayout from '../../components/layout-single-photo';

export const query = graphql`
  query MyQuery($slug: String!) {
    photosJson(slug: { eq: $slug }) {
      alt
      slug
      author
      title
      description
      id
      photoId
      prev
      next
      image {
        childImageSharp {
          gatsbyImageData
          original {
            src
          }
        }
      }
    }
  }
`;

export default function Art({ data }) {
  const photos = data.photosJson;
  // console.log(data);
  return (
    <>
      <Helmet>
        <script type='application/ld+json'>
          {`
        {
          "@context": "https://www.schema.org",
          "@type": "photograph",
          "name": "${photos.title}",
          "description": "${photos.description}",
          "keywords": "art, body, landscape, photography, monochrome, black&white",
          "author": "${photos.author}",
          "creator": "${photos.author}",
          "copyrightNotice": "© ${photos.author}",
          "creditText": "© ${photos.author}"
          }
        `}
        </script>
      </Helmet>
      <SinglePhotoLayout
        path={photos.slug}
        title={photos.title}
        description={photos.description}
        image={photos.image.childImageSharp.original.src}
      >
        <div className='prevNext'>
          <Link to={`/fotografies/${photos.prev}`}>anterior</Link>
          <Link to={`/#header`}>inici</Link>
          <Link to={`/fotografies/${photos.next}`}>següent</Link>
        </div>

        <GatsbyImage image={getImage(photos.image)} />

        <p className='copyright'>
          {`Fotografia: © `}
          {photos.author}
        </p>
      </SinglePhotoLayout>
    </>
  );
}
